import { Query } from '@softline/core';
import { DeliveryNoteQueryRow } from '../types/delivery-note-query-row';

const ROW_PAGE_COLUMN = 'delivery_note.id';

/** The grid's row pages request the document id (Symbole column); the page filter's
 *  distinct-value and count queries never do. Deciding on the query, not the response,
 *  keeps an empty page a page: its total is 0, not unknown. */
export function isRowPageQuery(query: Query<DeliveryNoteQueryRow>): boolean {
  return (query.columns ?? []).some((column) => String(column.name) === ROW_PAGE_COLUMN);
}

const ORIGIN_NAME = 'delivery_note.origin_document_number';

/** A tree child page (the corrections of one original): its `lastRow` counts the children, not
 *  the list. Assumes no page-filter item targets `origin_document_number`. */
export function isChildPageQuery(query: Query<DeliveryNoteQueryRow>): boolean {
  return hasOriginEquals(query.filters);
}

function hasOriginEquals(filter: unknown): boolean {
  if (!filter || typeof filter !== 'object') return false;
  const node = filter as { type?: string; name?: unknown; filters?: unknown[] };
  if (node.type === 'numberEquals' && String(node.name) === ORIGIN_NAME) return true;
  return (node.filters ?? []).some(hasOriginEquals);
}
